export default __webpack_public_path__ + "static/media/laundry2-before-480w.4bb95993.png";